/** Situações das naturezas de vendas */
export interface NaturezaVendaSituacao {
    id: number,
    nome: string;
}

export const naturezaVendaAtiva: NaturezaVendaSituacao = {id: 1, nome: 'Ativa'};
export const naturezaVendaInativa: NaturezaVendaSituacao = {id: 2, nome: 'Inativa'};

export const naturezaVendaSituacoes: NaturezaVendaSituacao[] = [
    naturezaVendaAtiva,
    naturezaVendaInativa
];

/** Verifica se a situação da natureza de venda é Ativa */
export function isSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === naturezaVendaAtiva.id;
}

/** Verifica se a situação da natureza de venda é Inativa */
export function isSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === naturezaVendaInativa.id;
}
